<template>
  <div id="portfolio">
    <div id="header">
      <h1>ArowShot's Portfolio</h1>
    </div>
    <PortfolioPiece v-for="piece of pieces" :title="piece.title" :description="piece.description" :source="piece.source" :demo="piece.demo" :videoid="piece.videoid" :image="piece.image" :key="piece.id"/>
  </div>
</template>

<script>
import PortfolioPiece from './PortfolioPiece.vue';

export default {
  name: 'Portfolio',
  components: {
    PortfolioPiece
  },
  data() {
    return {
      pieces: [
        {
          id: 'portfolio',
          title: 'This portfolio',
          description: `I'm Kyle, I'm a plugin developer, Java developer, Javascript developer, bot developer, and web developer. I've spent a lot of time learning and practicing web and Javascript development in the past year, but in the past, I did a lot of work with Bukkit plugins and Java development. I didn't have any sort of portfolio before this, so I threw together some of my old projects, made sure they still ran, put them on GitHub, threw up an EC2 instance for a demo server, and made this portfolio using Vue.`,
          source: 'https://github.com/ArowShot/portfolio.kgas.me',
          demo: {
            content: 'This portfolio',
            link: 'https://portfolio.kgas.me/'
          }
        },
        {
          id: 'spellsplugin',
          title: 'SpellsPlugin',
          description: `I made this plugin in late 2014 for a client. However, I never got paid and he never got the plugin so I suppose it's mine now. The plugin adds a mana and spells system with object-oriented spell classes to make adding new spells easy and quick. Spells can require different amounts of mana, require certain wands to cast, and have vastly different effects. Some of the sample spells include a fireball spell, a flight spell, and a spell that throws a storm of flaming arrows.`,
          source: 'https://github.com/ArowShot/SpellsPlugin',
          videoid: 'Cy59JFFaFkQ',
          demo: {
            content: '54.172.153.4'
          }
        },
        {
          id: 'traitsplugin',
          title: 'TraitsPlugin',
          description: `Another plugin from 2014 for a client who never paid. This plugin is a replica of the old traits plugin on MassiveCraft (they may still have it but this was based on the very first version that came out). Each trait has a positive or negative points value, and each player may only add traits if the total points value of their traits stays below 150. Traits currently in the plugin include a variety of traits that add constant potion effects to the player, but also add traits that make the player immune to fall damage and make the player gain food constantly. Many more traits are possible with the object-oriented traits system, and adding new traits is very easy. Traits players choose are stored in a file and preserved through reloads and restarts.`,
          source: 'https://github.com/ArowShot/TraitsPlugin',
          videoid: 'ZVjWnO5JkiM',
          demo: {
            content: '54.172.153.4'
          }
        },
        {
          id: 'betterbackpacks',
          title: 'Better Backpacks',
          description: `This plugin was my first attempt at a released plugin. The plugin allows players to add chests to their chestplates. With a command, the player can open the chest and use it as a backpack. The contents of the backpack are stored in a file denoted by the backpack's ID, which is hidden in the lore of the chestplate. If I remake this plugin I would like to store the chest data in an NBT tag in the chestplate, but when I made this in 2015 I didn't know very much about NBT.`,
          source: 'https://github.com/ArowShot/BetterBackpacks',
          videoid: 'ZVseaSTNnPg',
          demo: {
            content: '54.172.153.4'
          }
        },
        {
          id: 'itemexchange',
          title: 'ItemExchange',
          description: `ItemExchange is my most recent plugin and was designed to replace an old plugin of the same name on a server that I play on. It uses a library called CivModCore for item GUIs and other utilities. The idea is players can create shop chests allowing them to sell items to other players automatically with their chests locked with a different plugin. I'm a big fan of item GUIs so this was a cool plugin to make. I ended up not having enough time or motivation to finish the plugin, but I definitely got it to a working state first.`,
          source: 'https://github.com/ArowShot/ItemExchange',
          videoid: 'MThlxXSWK00',
          demo: {
            content: '54.172.153.4'
          }
        },
        {
          id: 'headlessclient',
          title: 'Headless client',
          description: `This was my first attempt at analyzing the Minecraft multiplayer protocol and creating a program that could replicate it. I didn't write in support for all packets, but I did write enough to sign in and chat. I used it to make some basic bots way back. I eventually rewrote this whole thing in C# and it turned out a lot better, but I can't find the source code and it's not totally relevant.`,
          source: 'https://github.com/ArowShot/HeadlessClient',
          demo: {
            content: 'None'
          }
        },
        {
          id: 'quickerbytes',
          title: 'Quickerbytes',
          description: `Quicker Bytes was originally supposed to be a website similar to uber eats specifically for my school campus where students could register as drivers and other students could get food delivered to their dorm room. The name is a bit of a meme, a few of my friends were working on a similar project name "Quick Bites" but one of them refused to let me join them in developing it, so I started Quicker Bytes with one of my other friends to compete. Unfortunately, we all realized that the idea was pretty impractical, and without working with local businesses the logistics would be too chaotic for a hobby project so development mostly stopped. Now the project is mostly a testing ground for different AWS and serverless services, as well as a demo and portfolio piece.`,
          source: 'https://gitlab.com/the-quicksters/quickerbytes-frontend',
          image: 'quickerbytes.png',
          demo: {
            content: 'https://quickerbytes.netlify.com/',
            link: 'https://quickerbytes.netlify.com/'
          }
        },
        {
          id: 'rust-lua-vue',
          title: 'rust-lua-vue',
          description: `This is one of my favorite recent projects. This combines some of my favorite languages and frameworks: Vue, Rust, web assembly, and Lua. This project lets you run Lua scripts natively in the browser. I compiled the Lua VM with Rust bindings using web assembly, then put the site together using Vue, and for the code editor, I used Monaco (the editor that powers vscode).`,
          source: 'https://github.com/ArowShot/rust-lua-vue',
          image: 'lua.png',
          demo: {
            content: 'https://arowshot.github.io/rust-lua-vue/',
            link: 'https://arowshot.github.io/rust-lua-vue/'
          }
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#portfolio {
  background: #303030;
  min-height: 100vh;
  //width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  #header {
    color: #fff;
    background: #212121;
    width: 100%;
    text-align: center;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }
}
</style>
